/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

/**
* Returns an initialized field object.
*
* @private
* @returns {Object} initialized field object
*/
function initFieldObject() {
	return {
		'isStructType': false,
		'description': '',
		'byteLength': 0,
		'byteOffset': 0,
		'alignment': 0,
		'padding': 0,
		'enumerable': true,
		'writable': true,
		'default': void 0, // explicitly set to `undefined`
		'castingMode': 'none'
	};
}


// EXPORTS //

export default initFieldObject;
